<template>
  <v-card flat class="input-card pa-4">
    <div class="section-title mb-3 white--text">Notiz zum Durchgang</div>
    <v-textarea v-model="note" label="Beobachtungen, Schwierigkeit etc. (optional)" rows="3" outlined dense hide-details class="mb-4"></v-textarea>
    <v-btn color="primary" block large class="add-set-btn" @click="submit">
      <v-icon left>mdi-check</v-icon>
      Durchgang speichern
    </v-btn>
  </v-card>
</template>

<script>
export default {
  name: "SensoProInput",
  data() {
    return {
      note: "",
    }
  },
  methods: {
    submit() {
      // Wir speichern die Notiz als einzigen Wert für diesen "Satz"
      this.$emit("add-set", [{ text: "note", value: this.note || "Durchgang absolviert" }])
      this.note = "" // Feld zurücksetzen
    },
  },
}
</script>

<style scoped>
.input-card {
  background: transparent !important;
  box-shadow: none !important;
  border: none !important;
  padding: 0 !important;
}
.section-title {
  text-transform: uppercase;
  font-weight: 700;
  letter-spacing: 1px;
  font-size: 0.8rem;
  opacity: 0.8;
}
.add-set-btn {
  height: 56px !important;
  font-weight: 700;
  font-size: 1.1rem;
  border-radius: 16px;
  text-transform: uppercase;
  letter-spacing: 1px;
  width: 100%;
  box-shadow: 0 8px 20px rgba(0,0,0,0.3);
  background: linear-gradient(135deg, var(--v-primary-base), rgba(var(--v-primary-base-rgb), 0.6)) !important;
  border: 1px solid rgba(255,255,255,0.1);
}
</style>
